import { useQuery } from '@tanstack/react-query';

import UserService, { SearchParams } from '@/services/UserService';

export const SEARCH_USERS_QUERY_KEY = (params?: SearchParams) => [
  'searchUsers',
  params,
];

export function useSearchUsers(params: SearchParams) {
  const { data, isFetching, refetch } = useQuery({
    queryKey: SEARCH_USERS_QUERY_KEY(params),
    queryFn: () => UserService.search(params),
  });

  return {
    users: data,
    isLoading: isFetching,
    searchUser: refetch,
  };
}
